import React from "react";

import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box } from "@mui/system";
import { Button, Grid } from "@mui/material";
import authAxios from "setups/axios";
import { toastMessage } from "utils/toastMessage";
import toast, { Toaster } from "react-hot-toast";
import SyncIcon from '@mui/icons-material/Sync';

const Main = () => {
  const handleSync = async (e, value) => {
    let url = `/api/v1/sync/all`;

    // switch (value) {
    //   case "user":
    //     url = `/api/v1/sync/users`;
    //     break;
    //   case "dealer":
    //     url = `/api/v1/sync/dealers`;
    //     break;
    //   case "ro":
    //     url = `/api/v1/sync/ro`;
    //     break;
    //   case "taluka":
    //     url = `/api/v1/sync/taluka`;
    //     break;
    //   case "state":
    //     url = `/api/v1/sync/state`;
    //     break;
    //   case "territories":
    //     url = `/api/v1/sync/territories`;
    //     break;
    //   default:
    //     break;
    // }

    await authAxios()({
      url,
      method: "GET",
    })
      .then((response) => {
        toastMessage(response?.data?.message, "success");
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  return (
    <>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} md={8}>
          <Box
            style={{
              padding: "20px",
              border: "1px solid #eaeaea",
              borderRadius: "10px",
              boxShadow:
                "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
              background: "#fff",
            }}
          >
            <Grid item>
              <h2>Sync SAP APIs</h2>
            </Grid>
            <Grid container spacing={4} mt={2}>
              <Grid item xs={12} sm={12} md={3}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={(e) => handleSync(e)}
                  endIcon={<SyncIcon />}
                >
                  Sync
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {/* <Toaster /> */}
    </>
  );
};

const Sync = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default Sync;
